<template>
  <div class="page-container animate-fade-in-up">
    <PageHeader icon="el-icon-chat-line-square" title="话术与FAQ配置" subtitle="配置系统各模块的默认话术模板和常见问题解答" />

    <div class="template-wrapper">
      <div class="template-card">
        <div class="template-card-header">
          <div class="template-icon" style="background: linear-gradient(135deg, #FEF3C7, #FDE68A);">
            <i class="el-icon-chat-dot-square" style="color: #92400E;"></i>
          </div>
          <h3 class="template-card-title">话术模板</h3>
        </div>
        <div class="template-card-body">
          <div class="template-hint">配置系统各模块的默认话术模板，支持变量替换（如 {{employee_name}}）</div>
          <el-input
            type="textarea"
            v-model="form.speech"
            :rows="16"
            class="template-input"
            placeholder="请输入话术模板内容..."
            :disabled="!$hasPermission('template:edit')"
          />
        </div>
      </div>

      <div class="template-card">
        <div class="template-card-header">
          <div class="template-icon" style="background: linear-gradient(135deg, #D1FAE5, #A7F3D0);">
            <i class="el-icon-question" style="color: #065F46;"></i>
          </div>
          <h3 class="template-card-title">FAQ / 激励机制</h3>
        </div>
        <div class="template-card-body">
          <div class="template-hint">配置常见问题解答和激励机制说明</div>
          <el-input
            type="textarea"
            v-model="form.faq"
            :rows="16"
            class="template-input"
            placeholder="请输入FAQ内容..."
            :disabled="!$hasPermission('template:edit')"
          />
        </div>
      </div>
    </div>

    <div v-if="$hasPermission('template:edit')" class="template-footer">
      <el-button type="primary" size="large" class="btn-click" @click="saveTemplates">
        <i class="el-icon-check"></i> 保存配置
      </el-button>
      <el-button class="btn-click" @click="resetTemplates">重置为默认</el-button>
    </div>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'

const DEFAULT_SPEECH = '您好 {{employee_name}}，感谢您抽出时间来做这个调研...\n\n核心功能：\n1. 评估员工离职风险\n2. 团队风险热力图\n3. 离职特征库修正'
const DEFAULT_FAQ = 'Q: 如果部门离职率降低≥3%，有什么激励？\nA: 部门可获得该省成本的30%作为团建经费。\n\nQ: 成功保留高风险员工有什么奖励？\nA: 主管获得月度"人才保留之星"认可。'

export default {
  name: 'SurveyTemplateManage',
  components: { PageHeader },
  data() {
    return {
      form: { speech: '', faq: '' },
      currentTemplateId: null,
      loading: false
    }
  },
  computed: {
    taskId() {
      return this.$store.getters.currentTaskId || null
    }
  },
  created() {
    this.loadFromBackend()
  },
  methods: {
    async loadFromBackend() {
      try {
        const res = await this.$api.fetchTemplates(this.taskId ? { task_id: this.taskId } : {})
        const list = res.data || []
        // 优先取当前任务或全局的模板
        const item = list.find(t => t.task_id === this.taskId) || list.find(t => !t.task_id) || list[0]
        if (item) {
          this.form = { speech: item.speech || '', faq: item.faq || '' }
          this.currentTemplateId = item.template_id
        } else {
          this.form = { speech: DEFAULT_SPEECH, faq: DEFAULT_FAQ }
          this.currentTemplateId = null
        }
      } catch (e) {
        console.warn('[SurveyTemplate] 加载失败:', e.message)
        this.form = { speech: DEFAULT_SPEECH, faq: DEFAULT_FAQ }
      }
    },
    async saveTemplates() {
      try {
        if (this.currentTemplateId) {
          await this.$api.updateTemplate(this.currentTemplateId, {
            speech: this.form.speech,
            faq: this.form.faq
          })
        } else {
          const res = await this.$api.createTemplate({
            task_id: this.taskId,
            speech: this.form.speech,
            faq: this.form.faq
          })
          if (res.data && res.data.template_id) {
            this.currentTemplateId = res.data.template_id
          }
        }
        this.$message.success('话术配置已保存')
      } catch (e) {
        this.$message.error('保存失败：' + ((e.response && e.response.data && e.response.data.message) || e.message || '未知错误'))
      }
    },
    async resetTemplates() {
      try {
        await this.$confirm('确定重置为默认配置？', '提示')
        this.form = { speech: DEFAULT_SPEECH, faq: DEFAULT_FAQ }
        await this.saveTemplates()
        this.$message.success('已重置为默认')
      } catch (e) {
        // 取消
      }
    }
  }
}
</script>

<style scoped>
.page-container { max-width: 1200px; margin: 0 auto; }

.template-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
  gap: var(--space-xl);
  margin-bottom: var(--space-2xl);
}

.template-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.template-card-header {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--color-border-light);
}

.template-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.template-card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

.template-card-body {
  padding: var(--space-xl);
}

.template-hint {
  font-size: 13px;
  color: var(--color-text-muted);
  margin-bottom: var(--space-md);
}

.template-input {
  font-family: monospace;
}

.template-footer {
  display: flex;
  gap: var(--space-md);
  padding-top: var(--space-lg);
  border-top: 1px solid var(--color-border-light);
}
</style>
